export const REPORT_STATUS = Object.freeze({
  SUBMITTED: "Submitted",
  DRAFTED: "Drafted",
  VALIDATED: "Validated",
  RETURNED: "Returned",
  RETURN_TO_BANK: "Return",
});
